import { ArrowLeft, ArrowRight, Rocket } from 'lucide-react'
import { Button } from '@/components/ui/button'
import SpreadsheetSetupCard from './SpreadsheetSetupCard'
import { useGameVersion } from 'app/frontend/base/hooks/useGameVersion'

interface Props {
  createdTeam?: wowaudit.TeamReference
  isNewGuild: boolean
  onFinish: () => void
  onBack: () => void
}

const ReviewStep = ({ createdTeam, isNewGuild, onFinish, onBack }: Props) => {
  const gameVersion = useGameVersion()
  const hasCandidates = gameVersion.has('guild_candidates')

  return (
    <div>
      <div className='mb-6 flex flex-col items-center gap-3 text-center'>
        <span className='flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary'>
          <Rocket className='h-6 w-6' />
        </span>
        <h2 className='text-2xl font-semibold'>
          {isNewGuild ? 'Your guild is ready' : 'Your team is ready'}
        </h2>
        <p className='max-w-md text-muted-foreground'>
          {hasCandidates
            ? 'Head to the candidates page to collect the characters that want to join your guild.'
            : "Head to your team's dashboard to get started."}{' '}
          If you have any questions, feel free to reach out to us on{' '}
          <a
            href='https://discord.gg/86eUAFz'
            target='_blank'
            rel='noopener noreferrer'
            className='text-primary hover:text-primary/90'
          >
            Discord
          </a>
          .
        </p>
      </div>

      <div className='mx-auto flex max-w-sm flex-col items-center gap-3'>
        <Button type='button' onClick={onFinish} className='w-full gap-2'>
          {hasCandidates ? 'View candidates' : "View your team's data"}
          <ArrowRight className='h-4 w-4' />
        </Button>
      </div>

      {createdTeam && gameVersion.has('blizzard_api') ? (
        <>
          <div className='my-8 flex items-center gap-4'>
            <span className='h-px flex-1 bg-border' />
            <span className='text-sm font-medium text-muted-foreground'>
              OR
            </span>
            <span className='h-px flex-1 bg-border' />
          </div>

          <SpreadsheetSetupCard />
        </>
      ) : null}

      <div className='mt-8 flex items-center justify-between gap-2'>
        <Button
          type='button'
          variant='ghost'
          onClick={onBack}
          className='gap-2'
        >
          <ArrowLeft className='h-4 w-4' />
          Back
        </Button>
      </div>
    </div>
  )
}

export default ReviewStep
